import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { guardRoute } from "@/lib/policy/route-guard";
import { getKioskDevice } from "./-components/kiosk-api";
import { kioskMode } from "./-components/kiosk-mode";
import { KioskStaffSetup } from "./-components/kiosk-staff-setup";
import { KioskView } from "./-components/kiosk-view";
import { KioskWelcomeCard } from "./-components/kiosk-welcome-card";

export const Route = createFileRoute("/kiosk/")({
  // A no-op for a device and for an anonymous visitor, which have no `me`. It
  // only spares a signed-in person without `visitor:manage` a setup screen
  // they cannot use; the API refuses either way.
  beforeLoad: ({ context }) => guardRoute(context.me, "visitor-kiosk"),
  component: VisitorKiosk,
});

function VisitorKiosk() {
  const { me } = Route.useRouteContext();
  // Read once: activating or losing a registration reloads the page.
  const [device] = useState(getKioskDevice);
  const mode = kioskMode(device, me !== null);
  if (mode.kind === "device") return <KioskView />;
  if (mode.kind === "welcome") return <KioskWelcomeCard />;
  return <KioskStaffSetup />;
}
